export default class PoISelect {
  timer: any;
  prevElement: any;
  currentElement: any;
  eventListeners: any[];

  constructor() {
    this.timer = null;
    this.prevElement = null;
    this.currentElement = "placeholder";
    this.#init();
    this.eventListeners = [];
  }

  #init() {
    const tabs = document.querySelectorAll(".tab");
    const collapse = $("#collapsible-poi");

    //document.querySelectorAll(".x").forEach((span) => (span.innerHTML = 5));
    $(".x").each((index, span) => {
      if (span.classList.contains("hydrant")) {
        span.innerHTML = "50";
      } else {
        span.innerHTML = "100";
      }
    });

    $(document).ready(() => {
      const timeScale = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60];
      const distanceScale = [
        100, 200, 300, 400, 500, 750, 1000, 1500, 2000, 3000, 4000, 5000,
      ];

      $(".slider").slider({
        min: 0,
        max: 11,
        step: 1,
        animate: "fast",
        slide: (event: any, ui: any) => {
          var poi = event.target.id.split("-")[1];
          var checkedValue = $(
            "input[name^='radio-" + poi + "']:checked"
          ).val();

          this.resetTimer(() => this.timerCallback(poi));

          if (checkedValue === "time") {
            $(".x." + poi).html(timeScale[ui.value] as any);
          } else if (checkedValue === "distance") {
            $(".x." + poi).html(distanceScale[ui.value] as any);
          }
        },
      });

      $('[id^="profile-"]').selectmenu({
        change: (event, ui) => {
          var poi = event.target.id.split("-")[1];
          var params = this.retrieveValues(poi);

          this.resetTimer(() => this.timerCallback(poi));
        },
      });

      // @ts-ignore
      $("#isochronePoiWrapper").find('input[name^="radio-"]').checkboxradio({
        icon: false,
      });

      $("#isochronePoiWrapper")
        .find('input[name^="radio-"]')
        .on("change", (event) => {
          var selectedValue = $(event.target).val(); // distance or time
          var poi = $(event.target).attr("name")?.split("-")[1] || "";
          var sliderValue = $("#slider-" + poi).slider("value");

          if (selectedValue === "distance") {
            $(".metric." + poi).html(" Meter");
            $(".x." + poi).html(distanceScale[sliderValue] as any);
          } else if (selectedValue === "time") {
            $(".metric." + poi).html(" Minuten");
            $(".x." + poi).html(timeScale[sliderValue] as any);
          }
          this.createLegend(selectedValue?.toString() || "", poi);
          this.resetTimer(() => this.timerCallback(poi));
        });

      // @ts-ignore
      $('input[name^="checkbox-"]').checkboxradio({
        icon: false,
      });

      $('input[name^="checkbox-"]').on("change", (event) => {
        var poi = $(event.target).attr("name")?.split("-")[1] || "";
        this.resetTimer(() => this.timerCallback(poi));
      });
    });

    tabs.forEach((tab: any) => {
      tab.addEventListener("click", (e: any) =>
        this.handleTabClick(e, tabs as any)
      );

      if (tab !== tabs[tabs.length - 1]) {
        tab.style.borderBottom = "none";
      }
    });
    collapse.on("click", () => {
      if (collapse.prop("checked")) {
        $(".collapsible-content").css("visibility", "visible");
      } else {
        $(".collapsible-content").css("visibility", "hidden");
        this.resetTabs();
      }
    });
  }

  handleTabClick(e: any, tabs: any[]) {
    tabs.forEach((tab) => {
      tab.classList.remove("selected");
      tab.style.display = "none";
    });

    e.target.classList.add("selected");
    e.target.style.display = "block";

    var params = this.retrieveValues(e.target.id);

    if (!this.prevElement) {
      this.prevElement = e.target;
      this.currentElement = e.target;
      document
        .querySelector(`#${e.target.id}~.slider-wrapper`)
        ?.classList.toggle("hidden");
    } else {
      this.prevElement = this.currentElement;
      this.triggerEventListeners({
        poi: this.prevElement.id,
        action: "remove",
      });

      this.currentElement = e.target;
      if (this.prevElement === this.currentElement) {
        document
          .querySelector(`#${e.target.id}~.slider-wrapper`)
          ?.classList.toggle("hidden");

        if (
          document
            .querySelector(`#${e.target.id}~.slider-wrapper`)
            ?.classList.contains("hidden")
        ) {
          e.target.classList.remove("selected");
          this.triggerEventListeners({ poi: e.target.id, action: "remove" });
          tabs.forEach((tab) => {
            tab.style.display = "block";
          });
          this.removeLegend();
        } else {
          this.triggerEventListeners({
            poi: params.poi,
            profile: params.profile,
            metric: params.metric,
            value: params.range,
          });
          this.createLegend(params?.metric || "", params.poi[0]);
        }
        return;
      } else {
        document
          .querySelectorAll(".tab~.slider-wrapper")
          .forEach((tab) => tab.classList.add("hidden"));
        document
          .querySelector(`#${e.target.id}~.slider-wrapper`)
          ?.classList.toggle("hidden");
      }
    }
    this.triggerEventListeners({
      poi: params.poi,
      profile: params.profile,
      metric: params.metric,
      value: params.range,
    });
    this.createLegend(params.metric || "", params.poi[0]);
  }

  timerCallback(poi: string) {
    var params = this.retrieveValues(poi);
    this.triggerEventListeners({
      poi: params.poi,
      profile: params.profile,
      metric: params.metric,
      value: params.range,
    });
  }

  resetTimer(callback: Function) {
    clearTimeout(this.timer);
    this.timer = setTimeout(callback, 500);
  }

  registerEventListener(callback: Function) {
    this.eventListeners.push(callback);
  }

  triggerEventListeners(event: any) {
    for (let callback of this.eventListeners) {
      callback(event);
    }
  }

  retrieveValues(poi: string) {
    var profileSelect = $(`#profile-${poi}`);
    var selectedProfile = profileSelect.val();
    var radioButtons = $(`input[name=radio-${poi}]`);
    var checkboxes = $(`input[name=checkbox-${poi}]`);

    var checkedBoxes: any[] = [];
    checkboxes.each(function () {
      if ($(this).prop("checked")) {
        checkedBoxes.push($(this).val());
      }
    });
    if (checkedBoxes.length === 0) {
      checkedBoxes = [poi];
    }

    var selectedRadioValue;
    radioButtons.each(function () {
      if ($(this).prop("checked")) {
        selectedRadioValue = $(this).val();
        return false; // Exit the loop once a checked radio button is found
      }
    });

    var sliderValueSpan = $(`.desc .${poi}`);
    var sliderValue = parseInt(sliderValueSpan.text());

    return {
      profile: selectedProfile,
      metric: selectedRadioValue,
      range: sliderValue,
      poi: checkedBoxes,
    };
  }

  resetTabs() {
    //Check for selected tab
    var selectedTab = $(".tab.selected");
    if (selectedTab.length === 1) {
      this.triggerEventListeners({ poi: selectedTab[0].id, action: "remove" });
      selectedTab[0].classList.remove("selected");
      $(".tab~.slider-wrapper").addClass("hidden");
      $(".tab").css("display", "block");
      this.removeLegend();
    }
  }

  createLegend(metric: string, poi: string) {
    // @ts-ignore
    const legendContainer = d3.select("#poi-legend");

    const legendTimeData = [
      { label: "5 Min.", color: "#fde725" },
      { label: "10 Min.", color: "#c2df23" },
      { label: "15 Min.", color: "#86d549" },
      { label: "20 Min.", color: "#52c569" },
      { label: "25 Min.", color: "#2ab07f" },
      { label: "30 Min.", color: "#1e9b8a" },
      { label: "35 Min.", color: "#25858e" },
      { label: "40 Min.", color: "#2d708e" },
      { label: "45 Min.", color: "#38588c" },
      { label: "50 Min.", color: "#433e85" },
      { label: "55 Min.", color: "#482173" },
      { label: "60 Min.", color: "#440154" },
    ];
    const legendDistanceData = [
      { label: "100 m", color: "#fde725" },
      { label: "200 m", color: "#c2df23" },
      { label: "300 m", color: "#86d549" },
      { label: "400 m", color: "#52c569" },
      { label: "500 m", color: "#2ab07f" },
      { label: "750 m", color: "#1e9b8a" },
      { label: "1000 m", color: "#25858e" },
      { label: "1500 m", color: "#2d708e" },
      { label: "2000 m", color: "#38588c" },
      { label: "3000 m", color: "#433e85" },
      { label: "4000 m", color: "#482173" },
      { label: "5000 m", color: "#440154" },
    ];

    if (metric === "time") {
      legendContainer.selectAll("div").remove();
      legendContainer
        .selectAll("div")
        .data(legendTimeData)
        .enter()
        .append("div")
        .attr("class", "legend-item")
        .style("background-color", (d) => d.color)
        .style("color", (d, i) =>
          i >= legendTimeData.length / 2 ? "white" : "black"
        )
        .text((d) => d.label);
    } else if (metric === "distance") {
      legendContainer.selectAll("div").remove();
      legendContainer
        .selectAll("div")
        .data(legendDistanceData)
        .enter()
        .append("div")
        .attr("class", "legend-item")
        .style("background-color", (d) => d.color)
        .style("color", (d, i) =>
          i >= legendDistanceData.length / 2 ? "white" : "black"
        )
        .text((d) => d.label);
    }
  }

  removeLegend() {
    // @ts-ignore
    const legendContainer = d3.select("#poi-legend");
    legendContainer.selectAll("div").remove();
  }
}
